import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { changeSidebarButtonState } from "../../../dashboard/actions/dashboardSidebarActions";
import UserComponent from "../../../../common/components/UserComponent";

import {
  fetchUsersData,
  addUser,
  editUser,
  deleteUserIdData,
  toggleUserLogin,
} from "../../../../common/actions/UserActions";
import { fetchOrganizations } from "../../organizations/actions/organizationActions";

function OperatorComponent(props) {
  return (
    <UserComponent
      userType={"Operator"}
      fetchUsersData={props.fetchUsersData}
      addUser={props.addUser}
      editUser={props.editUser}
      deleteUserIdData={props.deleteUserIdData}
      toggleUserLogin={props.toggleUserLogin}
      usersInfo={props.operatorsInfo}
      changeSidebarButtonState={props.changeSidebarButtonState}
      userRole={"operators"}
      userState={"OPERATORS_BTN_ACTIVE"}
      netError={props.netError}
      organizations={props.organizations}
      fetchOrganizations={props.fetchOrganizations}
    />
  );
}

function mapStateToProps(state) {
  return {
    operatorsInfo: state.operatorsInfo.operatorsInfo,
    netError: state.operatorsInfo.netError,
    organizations: state.organizationsInfo?.organizationsInfo || [],
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      changeSidebarButtonState,
      fetchUsersData,
      addUser,
      editUser,
      deleteUserIdData,
      toggleUserLogin,
      fetchOrganizations,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(OperatorComponent);
